import "./UILabel.scss";

import React from "react";

export interface UILabelLinkProps {
  children?: any;
  label?: string;
  onClick: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

export default UILabelLink;

function UILabelLink(props: UILabelLinkProps) {
  return (
    <label className="link" onClick={props.onClick}>
      {props.children != null ? props.children : props.label}
    </label>
  );
}
